<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container" style="margin-top:88px">
      <p>&zwnj;</p>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">Favorites</li>
        </ol>
      </nav>
      <p>&zwnj;</p>

      <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Favorites </span>
      <p>&zwnj;</p>

      <ul class="nav nav-pills my-2 h5">
        <li class="nav-item">
          <router-link :to="`/FavoriteExhibitors/Page=${1}`">
            <a class="nav-link pointer ">Exhibitors</a>
          </router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link active">Products</a>
        </li>
      </ul>
      <div v-if="hasResult">
        <div class="row mt-3">
          <div class="col-lg-3 mt-4" v-for="item in GetFavPro">
            <div class="text-center bg-white pointer border card-effect" @click.prevent="goProDetial(item.ProNo)">
              <div class="logImgFrame my-2">
                <img :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.ProImg}`" width="75%" alt="" />
              </div>
              <div class="ProNameFrame px-2">
                <div style="height:50px; font-size:16px; font-weight:bold">
                  <div class="ellipsis_pro">
                    {{ item.ProName }}
                  </div>
                </div>
                <div class="mb-2" style="height:30px">
                  <p class="text-muted ellipsis_exh" style="font-size:12px">{{ item.ComName }}</p>
                </div>
              </div>
              <div class="py-1 border-top " @click.stop="ClickFav(item.ProNo)">
                <span
                  v-show="item.Fav == 1"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Remove"
                  style="color:#81878d"
                >
                  <i class="fas fa-trash-alt iconOpenHover"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- PC版分頁 -->
        <p>&zwnj;</p>
        <p>&zwnj;</p>

        <div class="PcDevice">
          <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
            <nav>
              <ul class="pagination pointer">
                <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                  <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                  </span>
                </li>
                <li class="page-item" :class="{ disabled: currentPage == 1 }">
                  <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                    <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                  </span>
                </li>
                <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                  <span class="page-link" @click="getPage(page)">{{ page }}</span>
                </li>

                <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                  <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                  </span>
                </li>
                <li
                  v-if="totaltenPageNum > 1"
                  class="page-item"
                  :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                >
                  <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                    <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                  </span>
                </li>
              </ul>
              <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
              <p>&zwnj;</p>
            </nav>
          </div>
        </div>

        <div class="MbDevice">
          <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
            <div v-if="currentPage > 10">
              <nav>
                <ul class="pagination pagination-lg pointer">
                  <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                    <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                    </span>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage == 1 }">
                    <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                      <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                    </span>
                  </li>
                  <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                    <span class="page-link" @click="getPage(page)">{{ page }}</span>
                  </li>

                  <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                    <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                    </span>
                  </li>
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                  >
                    <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                    </span>
                  </li>
                </ul>
                <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
              </nav>
            </div>

            <div v-else>
              <nav>
                <ul class="pagination pagination-sm pointer">
                  <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                    <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                    </span>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage == 1 }">
                    <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                      <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                    </span>
                  </li>
                  <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                    <span class="page-link" @click="getPage(page)">{{ page }}</span>
                  </li>

                  <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                    <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                    </span>
                  </li>
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                  >
                    <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                      <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                    </span>
                  </li>
                </ul>
                <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
                <p>&zwnj;</p>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <p>&zwnj;</p>

        <h3 class="mt-2">No Data</h3>
      </div>
      <p>&zwnj;</p>
      <p>&zwnj;</p>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        CSRF_Token: '',
        GetFavPro: [],

        currentPage: 2,
        totalPage: '',
        totalNo: '',
        ProductRawData: [],
        totaltenPageNum: 0,
        tenPageNum: 0,
        showpage: [],
        hasResult: true,
      }
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'ShowRoom', 'exhcode']),
    },

    methods: {
      goProDetial(id) {
        this.$router.push(`/ProductDetail/${id}`)
      },

      ClickFav(no) {
        const vm = this
        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/FavoritesProducts/${vm.exhcode}/${no}`
        const info = {
          CSRF: vm.CSRF_Token,
        }

        if (confirm('Please confirm if you would like to remove this product from favorites?')) {
          vm.$http.post(url, info).then(function(response) {
            if (response.data == '200') {
              vm.reGetProList()
            } else if (response.data == '252') {
              window.location.replace(`https://www.chanchao.com.tw/en/`)
            } else if (response.data == '251') {
              vm.alertText = 'Server is busy, please try again later.'

              vm.alertError()
            } else if (response.data == '253') {
              vm.reGetProList()
            }
          })
        } else {
          return false
        }
      },

      alertError() {
        const vm = this
        vm.$swal({
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',

          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      reGetProList() {
        const vm = this
        vm.$store.dispatch('updateLoading', true)

        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/Products/${vm.exhcode}?Regno=null&CatNo=&countrycode=&keyword=&Type=Fav&mode=page&Page=${vm.currentPage}&Lang=en`
          )
          .then((response) => {
            vm.GetFavPro = response.data.Products
            vm.$store.dispatch('updateLoading', false)
          })
      },

      //分頁

      getPage(page) {
        const vm = this
        document.location.href = `https://www.chanchao.com.tw/TairosAutomation/onlineexpo/FavoriteProducts/Page=${page}`
      },

      nextPage() {
        const vm = this
        let nextP = Number(vm.currentPage) + 1

        document.location.href = `https://www.chanchao.com.tw/TairosAutomation/onlineexpo/FavoriteProducts/Page=${nextP}`
      },

      lastPage() {
        const vm = this
        let lastP = Number(vm.currentPage) - 1

        document.location.href = `https://www.chanchao.com.tw/TairosAutomation/onlineexpo/FavoriteProducts/Page=${lastP}`
      },

      nexttenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum + 1
        vm.showpage = vm.ProductRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        document.location.href = `https://www.chanchao.com.tw/TairosAutomation/onlineexpo/FavoriteProducts/Page=${vm.currentPage}`
      },

      returntenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum - 1
        vm.showpage = vm.ProductRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        document.location.href = `https://www.chanchao.com.tw/TairosAutomation/onlineexpo/FavoriteProducts/Page=${vm.currentPage}`
      },
    },

    created() {
      $('.modal').modal('hide')
      this.$store.dispatch('ShowChatRoom', false)

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)
      const vm = this

      vm.currentPage = vm.$route.params.FavProPage

      vm.$store.dispatch('updateLoading', true)

      vm.$http
        .get(
          `https://www.chanchao.com.tw/apiOnlineExpo/v1/Products/${vm.exhcode}?Regno=null&CatNo=&countrycode=&keyword=&Type=Fav&mode=page&Page=${vm.currentPage}&Lang=en`
        )
        .then((response) => {
          vm.totalNo = response.data.DataTotal

          if (response.data.PageTotal > 0) {
            vm.hasResult = true

            vm.GetFavPro = response.data.Products
            vm.totalPage = response.data.PageTotal

            for (let i = 0; i < vm.totalPage; i++) {
              if (i % 10 === 0) {
                vm.ProductRawData.push([])
              }

              const page = parseInt(i / 10)
              vm.ProductRawData[page].push(i + 1)
            }

            vm.totaltenPageNum = vm.ProductRawData.length

            let anaNowPage = vm.currentPage - 1

            vm.tenPageNum = parseInt(anaNowPage / 10)
            vm.showpage = vm.ProductRawData[vm.tenPageNum]
            vm.$store.dispatch('updateLoading', false)
          } else {
            vm.$store.dispatch('updateLoading', false)
            vm.hasResult = false
          }
        })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      })
    },
  }
</script>

<style lang="scss" scoped>
  .logImgFrame {
    width: 230px;
    min-height: 200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ellipsis_pro {
    font-size: 15px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .ellipsis_exh {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }
</style>
